module.exports = __webpack_public_path__ + "static/img/2-5.d3a61bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/2-5.jpg
// module id = ujR3
// module chunks = 25